import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import ErrorService from '../../../core/errors/service/ErrorService';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import {PageNameConstants} from '../../../core/service/PageNameConstants';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {IAbschlussStateParams} from '../../../gesuch/gesuch.route';
import {getTSAnlaufstelleTypeValues, TSAnlaufstelleType} from '../../../models/enums/TSAnlaufstelleType';
import {getKantonCodeList, TSKantonCode} from '../../../models/enums/TSKantonCode';
import {TSRole} from '../../../models/enums/TSRole';
import TSAdresse from '../../../models/TSAdresse';
import TSAnlaufstelleWithUsers from '../../../models/TSAnlaufstelleWithUsers';
import TSBenutzer from '../../../models/TSBenutzer';
import TSGemeinde from '../../../models/TSGemeinde';
import TSPasswordData from '../../../models/TSPasswordData';
import DVBernUtil from '../../../utils/DVBernUtil';
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;

let template = require('./anlaufstelleRegistrierungView.html');
require('./anlaufstelleRegistrierungView.scss');

export class AnlaufstelleRegistrierungViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = AnlaufstelleRegistrierungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        siteKey: '<'
    };

}

export class AnlaufstelleRegistrierungViewController extends AbstractGesuchViewController<TSAnlaufstelleWithUsers> {

    form: IFormController;
    private anlaufstelle: TSAnlaufstelleWithUsers;
    private gemeindeToAdd: TSGemeinde | undefined;
    private sachbearbeiterToAdd: TSBenutzer | undefined;
    private sachbearbeiterList: Array<TSBenutzer>;
    private schaetzerToAdd: TSBenutzer | undefined;
    private schaetzerList: Array<TSBenutzer>;
    private createNew: boolean = true;

    private recaptchaResponse: string;
    private recaptchaLanguage: string;
    private siteKey: string; //captcha sitekey if reCaptcha is enabled, undefined otherwise

    static $inject = ['DVBernUtil', '$q', '$scope', '$log', '$state', 'AnlaufstelleRS', 'PasswordStrengthService',
        'ErrorService', 'SchadenfallModelManager', 'RoleUtilService', 'AuthServiceRS', 'DvDialog', 'PAGE_NAMES'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private  $q: IQService,
                $scope: IScope, private $log: ILogService,
                private $state: IStateService, private anlaufstelleRS: AnlaufstelleRS,
                private passwordStrengthService: PasswordStrengthService,
                private errorService: ErrorService, schadenfallModelManager: SchadenfallModelManager,
                private roleUtilService: RoleUtilService, private authService: AuthServiceRS,
                private dvDialog: DvDialog, private pageNames: PageNameConstants) {
        super($scope);
        this.anlaufstelle = new TSAnlaufstelleWithUsers();
        this.anlaufstelle.adresse = new TSAdresse();
        this.anlaufstelle.gemeinden = []; //could maybe do this directly in TSAnlaufstelle
        let verwalterToCreate = new TSBenutzer();
        verwalterToCreate.roles.push(TSRole.ANLAUFSTELLE_VERWALTER);
        verwalterToCreate.inaktiv = false;
        verwalterToCreate.passwordData = new TSPasswordData(verwalterToCreate.email);

        this.anlaufstelle.verwalter = verwalterToCreate;
    }

    $onInit() {
        super.$onInit();
        //eigentlich muessen wir hier nicht kopieren da wir nur neu erstellen aber es schadet ja auch nicht
        this.initialModel = this.anlaufstelle;
        this.model = angular.copy(this.anlaufstelle);
    }

    public getTSAnlaufstelleTypeValues(): Array<TSAnlaufstelleType> {
        return getTSAnlaufstelleTypeValues();
    }

    public save() {
        this.cleanUnnecessaryFields();
        let passwordValid = this.checkPassword();
        if (this.isModelValid() && this.model && this.model.verwalter && passwordValid) {
            this.model.verwalter.recaptchaResponse = this.recaptchaResponse;
            this.anlaufstelleRS.createAnlaufstelleRegistration(this.model).then((response: TSAnlaufstelleWithUsers) => {
                let abschlussState = new IAbschlussStateParams();
                abschlussState.titleText = 'ABSCHLUSS_TITLE_ANLAUFSTELLE_REG';
                abschlussState.messageText = 'ABSCHLUSS_TEXT_ANLAUFSTELLE_REG';
                abschlussState.buttonText = 'OK';
                abschlussState.stateToGoTo = 'loginanlaufstelle';
                this.$state.go(this.pageNames.ABSCHLUSS, abschlussState);
            });
        } else {
            this.$log.debug('Form was not valid');
        }
    }

    private cleanUnnecessaryFields() {
        if (this.isKantonType()) {
            this.model.gemeinden = []
        } else {
            this.model.kanton = undefined; //wenn wir den Kanton nicht brauchen nullen wir ihn
        }
    }

    public addGemeinde() {
        if (this.gemeindeToAdd) {
            this.model.gemeinden.push(this.gemeindeToAdd);
        }
        this.gemeindeToAdd = undefined;
    }

    deleteClicked(gemeindeToDelete: TSGemeinde, event: any) {
        let index = DVBernUtil.getIndexOfElementwithID(gemeindeToDelete, this.model.gemeinden);
        if (index > -1) {
            this.model.gemeinden.splice(index, 1);
        }
    }

    public isKantonType(): boolean {
        return this.model.anlaufstelleType !== undefined && this.model.anlaufstelleType === TSAnlaufstelleType.KANTON;
    }

    public cancel() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('loginanlaufstelle');
    }

    public kantonList(): Array<TSKantonCode> {
        return getKantonCodeList()
    }

    public translateKanton(kantonCode: TSKantonCode): string {
        return TSKantonCode[kantonCode];
    }

    public captchaEnabled(): boolean {
        // return true;
        if (this.siteKey !== undefined && this.siteKey !== null) {
            return true;
        }
        return false;
    }

    private checkPassword(): boolean {
        const anlaufstelle = this.getModel();
        if (anlaufstelle && anlaufstelle.verwalter && anlaufstelle.verwalter.passwordData) {
            const passwordData = anlaufstelle.verwalter.passwordData;
            if (passwordData) {
                return this.passwordStrengthService.checkIfValid(passwordData.password, passwordData.passwordRepeat);
            }
        }
        return false;

    }

}



// WEBPACK FOOTER //
// ./src/app/anlaufstelleverwaltung/component/anlaufstelleRegistrierungView/anlaufstelleRegistrierungView.ts